module.exports = __webpack_public_path__ + "static/img/qykbj.fe67eb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qykbj.png
// module id = 6u7j
// module chunks = 43